module.exports = __webpack_public_path__ + "img/av236.a45161aa.png";